import { Getters } from "vuex";
import { ReceiptChargingGetters, ReceiptChargingState } from "./types";

export const getters: Getters<ReceiptChargingState, ReceiptChargingGetters> =
  {};
